import {
  BASE_ADMIN_PATH,
  getBaseRequestConfig,
  LOCAL_BASE_PATH,
} from './baseRequestConfig';
import httpRequest from './httpRequest';

export function getSeries() {
  const baseRequestConfig = getBaseRequestConfig();
  const url = `${LOCAL_BASE_PATH}/series`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'GET',
  });

  return httpRequest(requestConfig);
}

export function getAdminSeries(accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${BASE_ADMIN_PATH}/series`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'GET',
  });

  return httpRequest(requestConfig);
}

export function getSingleSeries(seriesId, accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${LOCAL_BASE_PATH}/series/${seriesId}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'GET',
  });

  return httpRequest(requestConfig);
}

export function postSeries(body, accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${BASE_ADMIN_PATH}/series`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'POST',
    data: body,
  });

  return httpRequest(requestConfig);
}

export function putSeries(seriesId, body, accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${BASE_ADMIN_PATH}/series/${seriesId}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'PUT',
    data: body,
  });

  return httpRequest(requestConfig);
}

export function deleteSeries(accessToken, seriesId) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${BASE_ADMIN_PATH}/series/${seriesId}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'DELETE',
  });

  return httpRequest(requestConfig);
}

export function getAllSeriesPageConfig(ignore, accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${BASE_ADMIN_PATH}/series/page`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'GET',
  });

  return httpRequest(requestConfig);
}

export function putAllSeriesPageConfig(ignore, body, accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${BASE_ADMIN_PATH}/series/page`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'PUT',
    data: body,
  });

  return httpRequest(requestConfig);
}
